import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";
import { useIsReviewer } from "@app/utils/use-is-reviewer";
import { useReadonlyScope } from "@app/utils/use-readonly-scope";

/**
 * Returns true if the user can validate patient fields: an admin or one of MAGE-X's reviewers.
 *
 * Never inside a borrowed speciality: a validation is the clinician's truth, which no later reading
 * overrides, and a reader visiting another speciality is only a reader there (PT-74).
 */
export function useCanValidate(): boolean {
  const user = useUser((state) => state.user);
  const previewRole = usePreviewView((state) => state.previewRole);
  const readonlyScope = useReadonlyScope();
  const isReviewer = useIsReviewer();
  const userRole = (user as { role?: string } | null)?.role;
  const effectiveRole = previewRole ?? userRole;
  if (readonlyScope) return false;
  return effectiveRole === "admin" || isReviewer;
}
